import { TextField, Button } from "@mui/material";
import { Stack } from "@mui/system"
import React, { useState } from "react"
import { useAppDispatch } from "../../../../app/hooks";
import { toggleCaseLookup } from "../../../../app/slices/RadModuleSlice";
import { LookupResults } from "./LookupResults";

function Lookup(){
    const dispatch = useAppDispatch();
    const [searchText, setSearchText] = useState('');
    const [skip, setSkip] = React.useState(true)
    
    return <React.Fragment>
        <Stack direction='row'>
            <TextField label='Name or Account #' name='searchText' value={searchText} onChange={(e)=>{setSkip(true); setSearchText(e.currentTarget.value);}} size='small' sx={{backgroundColor:'white'}}/>
            <Button color='primary' variant="outlined" onClick={()=>{ setSkip(false); dispatch(toggleCaseLookup());}} disabled={searchText === ''} size='small'>Search</Button>
        </Stack>
        <LookupResults searchText={searchText} skip={skip}/>
    </React.Fragment>
}

export {Lookup}